import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { handleFetchAutoRequest } from "../../api/autorequests";
import DeleteRequest from "./components/DeleteRequest";
import CompleteRequest from "./components/CompleteRequest";
import { useState } from "react";
import { DeleteOutlined, LeftOutlined } from "@ant-design/icons";

export default function OneAutoRequest() {
  const { id } = useParams();
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [completeModal, setCompleteModal] = useState<boolean>(false);

  const { data: autorequest } = useQuery({
    queryKey: ["autorequests", id],
    queryFn: () => handleFetchAutoRequest({ _id: id }),
  });

  return (
    <div>
      <div className="flex justify-between items-center border-b  px-2 py-1 border-t bg-gray-50 text-black">
        <Link
          to={"/autoline/requests"}
          className="flex items-center justify-center px-2"
        >
          <LeftOutlined /> Back
        </Link>
        <div className="flex">
          <div className="flex justify-end">
            {!autorequest?.isCompleted && (
              <button
                onClick={() => {
                  setCompleteModal(true);
                }}
                className="border py-1 px-2 mx-1 flex items-center bg-green-50 text-green-800 shadow-sm"
              >
                Mark completed
              </button>
            )}

            <button
              onClick={() => {
                setDeleteModal(true);
              }}
              className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm"
            >
              <DeleteOutlined />
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row justify-between border p-2 m-1 bg-white">
        <div className="">
          <div className="font-bold capitalize text-lg">
            Request For: {autorequest?.requestedFor?.name}
          </div>
          <div className="text-gray-600">
            For the Role: {autorequest?.designation}
          </div>
        </div>
      </div>
      <div className="m-1">
        <div className="mx-auto bg-white shadow-sm  p-8">
          <div className="grid grid-cols-12 gap-x-8">
            <div className="col-span-12 sm:col-span-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="col-span-1">
                  <h2 className="text-md font-bold text-karimjee border-b-2 border-gray-300 pb-2 mb-4">
                    General Info
                  </h2>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Name:</span>{" "}
                    {autorequest?.name}
                  </p>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Email:</span>{" "}
                    {autorequest?.email}
                  </p>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Designation:</span>{" "}
                    {autorequest?.designation}
                  </p>
                  <p className="text-gray-700">
                    <span className="font-semibold">Status:</span>{" "}
                    <span
                      className={`text-gray-700 ${autorequest?.isCompleted && "text-green-600"
                        }`}
                    >
                      {autorequest?.status || "-"}
                    </span>
                  </p>
                </div>

                <div className="col-span-1">
                  <h2 className="text-md font-bold text-karimjee border-b-2 border-gray-300 pb-2 mb-4">
                    Role Info
                  </h2>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Role:</span>{" "}
                    {autorequest?.role.name}
                  </p>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Max Level:</span>{" "}
                    {autorequest?.role.max}
                  </p>
                  <p className="text-gray-700">
                    <span className="font-semibold">Min Level:</span>{" "}
                    {autorequest?.role.min}
                  </p>
                </div>

                <div className="col-span-1">
                  <h2 className="text-md font-bold text-karimjee border-b-2 border-gray-300 pb-2 mb-4">
                    Requested For
                  </h2>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Name:</span>{" "}
                    {autorequest?.requestedFor?.name}
                  </p>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Email:</span>{" "}
                    {autorequest?.requestedFor?.email}
                  </p>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Job Title:</span>{" "}
                    {autorequest?.requestedFor?.jobTitle}
                  </p>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Department:</span>{" "}
                    {autorequest?.requestedFor?.department}
                  </p>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Work Location:</span>{" "}
                    {autorequest?.requestedFor?.workLocation}
                  </p>
                  <p className="text-gray-700">
                    <span className="font-semibold">Access Level:</span>{" "}
                    {autorequest?.requestedFor?.accessLevel}
                  </p>
                </div>

                <div className="col-span-1">
                  <h2 className="text-md font-bold text-karimjee border-b-2 border-gray-300 pb-2 mb-4">
                    Requested By
                  </h2>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Name:</span>{" "}
                    {autorequest?.requestedBy?.name}
                  </p>
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">Email:</span>{" "}
                    {autorequest?.requestedBy?.email}
                  </p>
                  <p className="text-gray-700">
                    <span className="font-semibold">Job Title:</span>{" "}
                    {autorequest?.requestedBy?.jobTitle}
                  </p>
                </div>
                <div className="col-span-1">
                  <h2 className="text-md font-bold text-karimjee border-b-2 border-gray-300 pb-2 mb-4">
                    Companies
                  </h2>
                  <ul className="list-disc list-inside text-gray-700">
                    {autorequest?.companies.map(
                      (company: any, index: number) => (
                        <li key={index}>{company}</li>
                      )
                    )}
                  </ul>
                </div>

                <div className="col-span-1">
                  <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="col-span-1">
                      <h2 className="text-md font-bold text-karimjee border-b-2 border-gray-300 pb-2 mb-4">
                        Additional Info
                      </h2>
                      <p className="text-gray-700 mb-2">
                        <span className="font-semibold">Request Accepted:</span>{" "}
                        {autorequest?.isAccepted ? "Yes" : "No"}
                      </p>
                      <p className="text-gray-700 mb-2">
                        <span className="font-semibold">
                          Request Completed:
                        </span>{" "}
                        {autorequest?.isCompleted ? "Yes" : "No"}
                      </p>
                      <p className="text-gray-700 mb-2">
                        <span className="font-semibold">Request Notified:</span>{" "}
                        {autorequest?.isNotified ? "Yes" : "No"}
                      </p>
                      <p className="text-gray-700">
                        <span className="font-semibold">User Account:</span>{" "}
                        {autorequest?.isNewUser ? "New" : "Existing"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-4">
              {autorequest?.description && (
                <div className="col-span-1">
                  <h2 className="text-md font-bold text-karimjee border-b-2 border-gray-300 pb-2 mb-2">
                    Description
                  </h2>
                  <div className="mb-8">{autorequest?.description}</div>
                </div>
              )}
              {autorequest?.imageUrl && (
                <div className="col-span-1">
                  <h2 className="text-md font-bold text-karimjee border-b-2 border-gray-300 pb-2 mb-4">
                    Screenshot / Image
                  </h2>
                  <img src={autorequest?.imageUrl} alt="" width={300} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <DeleteRequest
        isVisible={deleteModal}
        setVisible={setDeleteModal}
        selected={autorequest || {}}
        redirect={true}
      />

      <CompleteRequest
        isVisible={completeModal}
        setVisible={setCompleteModal}
        selected={autorequest || {}}
      />
    </div>
  );
}
